'use client';

import { Title, TitleLevels, TitleMarkup } from '@bytel/trilogy-react';

import { CartType, OptionType } from '@app-types/product';
import { TagEventType } from '@app-types/tracking';

import useTracking from '@hooks/use-tracking';

import { OptionWithPrice } from './option-with-price';

interface OptionsListProps {
    updatable?: boolean;
    cart: CartType;
    updateCartOptions?: (option: OptionType) => void;
}

export function OptionsList({ updatable, cart, updateCartOptions }: Readonly<OptionsListProps>) {
    const { sendTag } = useTracking();
    const handelDeleteOption = (o: OptionType) => {
        if (!cart?.product) return;

        if (updateCartOptions) {
            updateCartOptions(o);
            if (o.gencode === cart.product.option5g?.gencode) {
                sendTag(
                    {
                        actionClic: 'Clic_deselection',
                        categorieClic: 'Parcours_configurateur_5g',
                        nomClic: 'Suppression_option_5g',
                    },
                    TagEventType.CLICK,
                );
            }
        }
    };
    if (!cart.options?.length) return null;

    const neededGencodes =
        cart.product?.neededElements?.flatMap((el) => el.alternatives.map((alt) => alt.identifier)) ?? [];

    return (
        <>
            <Title level={TitleLevels.FIVE} markup={TitleMarkup.H3}>
                Vos options
            </Title>
            {cart.options.map((option) => (
                <OptionWithPrice
                    option={option}
                    subTitleClassName='has-text-primary'
                    period='mois'
                    handleDelete={() => handelDeleteOption(option)}
                    key={option.gencode}
                    updatable={updatable && !neededGencodes.includes(option.gencode)}
                    priceLevel={6}
                />
            ))}
        </>
    );
}
